var allShopSections = document.querySelectorAll('.lsg-shop');

allShopSections.forEach((section) => {

// GALLERY LOGIC

  var shopGalleryThumbs = section.querySelector(".lsg-shop__gallery-thumbs");
  var shopGalleryImages = section.querySelectorAll(".lsg-shop__gallery-main-image");

  if (shopGalleryThumbs) {
    galleryToShow(shopGalleryImages.length)
  }

//GALLERY LOGIC
function galleryToShow(slidesLength) {
  $(".lsg-shop__gallery-main").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    fade: true,
    asNavFor: $(".lsg-shop__gallery-thumbs"),
  });

  $(".lsg-shop__gallery-thumbs").slick({
    slidesToShow: slidesLength,
    slidesToScroll: 1,
    asNavFor: $(".lsg-shop__gallery-main"),
    dots: false,
    arrows: false,
    focusOnSelect: true,
  });
}

//SHOP LOGIC
let allProducts = section.querySelectorAll(".lsg-shop__product");
let productPrice = section.querySelector('.lsg-shop__button-price')
let productDesciption = section.querySelector('.lsg-shop__product-description')
let productTitle = section.querySelector('.lsg-shop__product-title')
let currentVariantInput = section.querySelector('.lsg-shop__variant-id')
let popupTrigger = section.querySelector('.lsg-shop__popup-trigger')
let currentVariantQuantity = section.querySelector('.lsg-shop__variant-quantity')
let currentVariantSellingPlan = section.querySelector('.lsg-shop__variant-selling-plan')
let sellingPlan = section.querySelector('.lsg-shop__selling-plans');

// GET CURRENT PRODUCT

  allProducts.forEach((product) => {
    product.addEventListener("click", () => {
        allProducts.forEach((p) => {
            p.classList.remove('active-product');
        });

        product.classList.toggle('active-product');

        currentVariantInput.value = currentVariant().id

        let currentPopupImageSrc = product.dataset.nutrition

        updatePopupImage(currentPopupImageSrc)

        if(getCurrentProductJson()){
            updateProduct(getCurrentProductJson())
            updateGallery(getCurrentProductJson())
            updateOptions(getCurrentProductJson())
        }
    })
})

//UPDATE OPTIONS
function updateOptions(currentProduct) {
  let selectOptions = section.querySelector(".lsg-shop__selling-plans");
  selectOptions.innerHTML = "";

  let newSelect = section.querySelector('.lsg-shop__selling-plans');

    currentProduct.selling_plan_groups.forEach((group) => {
      group.selling_plans.forEach((option, index) => {
        let optionElement = document.createElement('option');
        optionElement.value = option.id;
        optionElement.textContent = option.name;
        if (index === 0) {
          optionElement.selected = true;
        }

        newSelect.appendChild(optionElement);
      });
    });
}

function getCurrentProductJson() {
  return JSON.parse(section.querySelector('.lsg-shop__product.active-product').querySelector('.lsg-shop__product-json').textContent);
}

function currentVariant() {
  return getCurrentProductJson().variants.find((el) => {
    return el.available === true
  })}


//UPDATE POPUP IMAGE

function updatePopupImage (currentImage) {
    if (popupTrigger) {
      let popupImage = section.querySelector('.lsg-shop-popup__image img');

      if (currentImage) {
        popupTrigger.style.display = "flex"
        popupImage.src = currentImage
      }else {
        popupTrigger.style.display = "none"
      }
    }
}

//UPDATE CURRENT PRODUCT

function updateProduct(currentProduct) {
    productTitle.innerHTML = currentProduct.title
    productDesciption.innerHTML = currentProduct.description

    let activeProduct = section.querySelector('.active-product')
    let activeProductText = activeProduct.closest('.lsg-shop__products-content').querySelector('.lsg-shop__product-current')
    let allActiveProductTexts = section.querySelectorAll('.lsg-shop__product-current')

    allActiveProductTexts.forEach((el) => {
      el.innerHTML = ""
    })

    activeProductText.innerHTML = currentProduct.title
}

 // POPUP TOGGLE
 var popupTriggers = section.querySelectorAll(".js-popup-toggle-button");
 var popup = section.querySelector(".lsg-shop-popup");
 var html = document.querySelector("html");

 if (popup) {
     setTimeout(function () {
         popup.style.display = "flex";
     }, 3000);
     popupTriggers.forEach((trigger) => {
         trigger.addEventListener("click", () => {
             popup.classList.toggle("active");
             html.classList.toggle("no-scroll");
         });
     });
 }

//UPDATE GALLERY

function updateGallery(currentProduct) {
    let galleryMain = section.querySelector(".lsg-shop__gallery-main");
    let galleryThumbs = section.querySelector(".lsg-shop__gallery-thumbs");

    if ($(galleryMain).hasClass('slick-initialized')) {
      $(galleryMain).slick('unslick');
    }

    if ($(galleryThumbs).hasClass('slick-initialized')) {
      $(galleryThumbs).slick('unslick');
    }


    // Clear existing slides
    galleryMain.innerHTML = "";
    galleryThumbs.innerHTML = "";

    // Render new slides for the clicked product
    currentProduct.images.slice(0,6).forEach((image) => {
      // Add slide to main gallery
      let mainSlide = document.createElement("div");
      mainSlide.className = "lsg-shop__gallery-main-image";
      mainSlide.innerHTML = `<img src='${image}'>`;
      galleryMain.appendChild(mainSlide);

      // Add slide to thumbs gallery
      let thumbSlide = document.createElement("div");
      thumbSlide.className = "lsg-shop__gallery-thumb";
      thumbSlide.innerHTML = `<img src='${image}'>`;
      galleryThumbs.appendChild(thumbSlide);
    });

      // Reinitialize Slick slider for updated galleries
   galleryToShow(currentProduct.images.length)
  }



  // FORMAT CURRENCY
  function formatCurrency(amount, currency = 'USD') {
    const formattedAmount = amount.toLocaleString('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return formattedAmount;
}

//OPTION TABS
const optionContainers = section.querySelectorAll(".lsg-shop__options");
const subscribeContent = section.querySelector(".lsg-shop__subscribe-content")

optionContainers.forEach((container) => {
  const subscribeBox = container.querySelector(".lsg-shop__subscribe");
  const oneTimeBox = container.querySelector(".lsg-shop__onetime");

  subscribeBox.addEventListener("click", () => {
    subscribeBox.classList.add("active-option");
    oneTimeBox.classList.remove("active-option");
    subscribeContent.classList.add('active');
    updatePrice()
    currentVariantSellingPlan.value = sellingPlan.value
  });

  oneTimeBox.addEventListener("click", () => {
    oneTimeBox.classList.add("active-option");
    subscribeBox.classList.remove("active-option");
    subscribeContent.classList.remove('active')
    updatePrice()
    currentVariantSellingPlan.value = ""
  });
});

function changeFrequency() {
  if (subscribeContent.classList.contains('active')) {
  sellingPlan.addEventListener('change', function (){
      currentVariantSellingPlan.value = sellingPlan.value
    })
  }
}

changeFrequency()

//QUANTITY

var quantityInput = section.querySelector(".lsg-shop__qty-input");
var qtyIncreaseButton = section.querySelector(".lsg-shop__qty-increase");
var qtyDecreaseButton = section.querySelector(".lsg-shop__qty-decrease");

qtyDecreaseButton.addEventListener("click", function () {
  updateQuantity(-1);
  updatePrice()
});

qtyIncreaseButton.addEventListener("click", function () {
  updateQuantity(1);
  updatePrice()
});

function updateQuantity(change) {
  var currentQuantity = parseInt(quantityInput.value);

  if (!isNaN(currentQuantity + change) && currentQuantity + change >= 1) {
    var newQuantity = currentQuantity + change;
    quantityInput.value = newQuantity;
    currentVariantQuantity.value = newQuantity;
    updatePrice();
  }
}

//UPDATE PRICE

function updatePrice() {
  var currentQuantity = parseInt(quantityInput.value);

  if (subscribeContent.classList.contains('active')) {
    productPrice.innerText = formatCurrency(currentVariant().selling_plan_allocations[0].price / 100 * currentQuantity);
  }else {
    productPrice.innerText = formatCurrency((currentVariant().price / 100) * currentQuantity);
  }
}

//VALUE PROPS MOBILE

var valueProps = section.querySelector(".lsg-shop__gallery-props");
var valuePropsMob = section.querySelector(".lsg-shop__gallery-props-mob");
if (valueProps && valuePropsMob) {
  if (window.innerWidth < 768) {
    valuePropsMob.appendChild(valueProps);
  }
}

});



